// extracted by mini-css-extract-plugin
export default {"root":"segmented-control_root__SSQPL"};